export function TicketIcon() {
  return (
    <svg
      className="svg-icon"
      style={{
        width: "1em",
        height: "1em",
        verticalAlign: "middle",
        fill: "currentcolor",
        overflow: "hidden",
      }}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M421.31584 1022.592c-25.984 0-50.304-10.24-68.416-28.864l-77.76-80.192a36.544 36.544 0 0 1 0.64-51.584 84.48 84.48 0 0 0 25.728-59.968c0.256-22.784-8.384-44.224-24.32-60.48-31.872-32.64-88-33.28-120.512-1.536a39.616 39.616 0 0 1-26.048 10.432 36.48 36.48 0 0 1-25.728-11.136l-77.696-80A94.848 94.848 0 0 1 0.00384 591.488c0.32-25.6 10.56-49.472 28.8-67.392L535.55584 27.648c36.8-35.84 99.648-35.008 135.296 1.472l77.824 80.256a36.48 36.48 0 0 1-0.704 51.584 84.864 84.864 0 0 0-25.664 60.032c-0.256 22.784 8.32 44.224 24.256 60.544 31.808 32.576 88 33.28 120.64 1.408a42.24 42.24 0 0 1 26.048-10.368 36.48 36.48 0 0 1 25.728 11.072l77.632 80.128c17.664 17.92 27.392 41.984 27.2 67.52-0.256 25.6-10.432 49.6-28.736 67.52l-506.88 496.512a95.36 95.36 0 0 1-66.816 27.264z"
        fill="#FF0000"
      />
      <path
        d="M334.53184 595.584a36.48 36.48 0 0 1-25.856-62.4l204.16-204.16a36.544 36.544 0 1 1 51.712 51.712l-204.16 204.16a36.608 36.608 0 0 1-25.856 10.688zM443.77984 704.768a36.48 36.48 0 0 1-25.856-62.4l204.16-204.16a36.48 36.48 0 1 1 51.648 51.712l-204.096 204.16a36.608 36.608 0 0 1-25.856 10.688z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
